export default __webpack_public_path__ + "static/media/character-6.6e1402bd.png";